var DialogLocationEnvironmentModule = /** @class */ (function () {
    function DialogLocationEnvironmentModule() {
    }
    return DialogLocationEnvironmentModule;
}());
export { DialogLocationEnvironmentModule };
